'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var $pdfButton = (0, _jquery2.default)('[data-pdf]');

    if ($pdfButton.length === 0) {
        return;
    }

    $pdfButton.click(function (e) {
        e.preventDefault();
        var that = this;

        _jquery2.default.when(_jquery2.default.getScript("/Content/wowbook/pdf.combined.min.js"), _jquery2.default.getScript("/Content/wowbook/wow_book.min.js")).done(function () {
            showPdf(that);
        });
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Common');

function createCloseButton() {
    var $pdfWrap = (0, _jquery2.default)('.wowbook-container', document);

    // prevent scroll
    (0, _jquery2.default)('body').css('overflow', 'hidden');

    $pdfWrap.append('<button id="pdfClose" class="pdf-close">' + Resx.Common.Close + '</buton>');

    (0, _jquery2.default)('#pdfClose', document).on('click', function (e) {
        e.preventDefault();
        closePDF();
    });
};

function closePDF() {
    (0, _jquery2.default)('.wowbook-container', document).remove();

    (0, _jquery2.default)('body').css('overflow', 'initial');

    (0, _jquery2.default)('.ie11 body', document).attr('style', '');
}

function showPdf(elm) {
    var $this = (0, _jquery2.default)(elm);

    (0, _jquery2.default)('body').append('<div id="wowBook" />');

    var bookOptions = {
        pdf: $this.data('pdf'),

        height: 600,
        width: 800,
        maxHeight: 800,
        centeredWhenClosed: true,
        hardcovers: true,
        pageNumbers: false,
        toolbar: "lastLeft, left, right, lastRight, zoomin, zoomout, slideshow, download",
        thumbnailsPosition: 'left',
        responsiveHandleWidth: 50,
        container: window,
        containerPadding: "20px",
        flipSound: false,
        deepLinking: false,
        updateBrowserURL: false,
        onPDFLoadError: function onPDFLoadError(e) {
            _notify2.default.error(Resx.App.PdfNotFound);
            closePDF();
        }
    };

    (0, _jquery2.default)('#wowBook').wowBook(bookOptions); // create the book

    createCloseButton();
}

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/pdfPopup.js
// module id = 1183
// module chunks = 0